<template>
  <v-container class="pa-0">
    <div class="gt-tag ">
      <div class="gt-tag-bg forum"></div>
      <div class="gt-tag-text ">
        <h4><v-icon color="white">mdi-star</v-icon>Favoritos</h4>
      </div>
    </div>
    <v-row>
      <v-col cols="12" class="my-10 mb-0">
        <v-text-field
          v-model="searchArquivos"
          clearable
          color="#6e6e6e"
          class="mt-0 pt-0"
          placeholder="Buscar Favoritos"
          v-on:keyup.enter="reloadArquivos()"
        >
          <template v-slot:append-outer>
            <v-btn text>Buscar <v-icon color="#F15A24">mdi-magnify</v-icon></v-btn>
          </template>
        </v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="favorito" cols="12" v-for="f in favoritos" :key="f.id">
        <v-row>
          <v-col cols="10"> 
            <p>
              <a :href="`/painel/lei/${f.id_lei.id_lei}/${sanitizeTitle(f.id_lei.numero_lei)}`">{{ f.id_lei.numero_lei }}</a> - {{ f.date_created | brdatetime }}
            </p>
            <v-icon class="mr-3">mdi-text</v-icon><span v-html="f.observacoes"></span>
          </v-col>
          <v-col cols="2" class="d-flex align-center justify-center"> 
            <v-btn text>Excluir <v-icon color="#F15A24">mdi-delete</v-icon></v-btn>
          </v-col>

        </v-row>
        
      </v-col> 

    </v-row>
  </v-container>

</template>
<style scoped> 
.favorito { 
  border:1px dashed #6f6f6f;
}
a { 
  color:#F15A24;
  text-decoration: none;
}
</style>
<script> 
export default { 
  name:"Favoritos", 
  data() { 
    return { 
      searchArquivos: null,
      favoritos:[ ]
    }
  },
  mounted() {
    this.reloadFavoritos()
  },
  methods:{ 
    reloadFavoritos(){
      this.$http('items/favoritos?fields=*,id_lei.numero_lei,id_lei.id_lei&filter[user_created][_eq]='+ this.$store.state.user.id).then(res => { 
        this.favoritos = res.data.data
      }) 
    },
    sanitizeTitle(title) {
      var slug = "";
      // Change to lower case
      var titleLower = title.toLowerCase();
      // Letter "e"
      slug = titleLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, "e");
      // Letter "a"
      slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, "a");
      // Letter "o"
      slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, "o");
      // Letter "u"
      slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, "u");
      // Letter "d"
      slug = slug.replace(/đ/gi, "d");
      // Trim the last whitespace
      slug = slug.replace(/\s*$/g, "");
      // Change whitespace to "-"
      slug = slug.replace(/\s+/g, "-");

      return slug;
    }, 
 }
}
</script>